<template>
  <div style="margin-top: 50px">
    <v-form @submit.prevent="submit" ref="form" class="form-container">
      <div>
        <vue2Dropzone
          class="c-question-image-upload"
          id="upload-photo"
          :options="dropzoneOptions"
          ref="dropzone"
          :useCustomSlot="true"
          @vdropzone-file-added="onFileAdded"
        >
          <div
            ref="dropzoneContent"
            class="c-question-image-upload__dropzone dz-preview dz-image-preview"
          >
            <div class="upload__preview"></div>
            <div
              class="d-flex text-center"
              style="justify-content: center; align-items: center; height: 320px"
            >
              <div>
                <div
                  class="dropzone__icon-upload"
                  style="margin: 0 auto; height: 250px; width: 250px"
                  v-html="iconUpload"
                ></div>
                <div>
                  <b>If you want to add an image, drag it or click here</b>
                </div>
                <div>Minimum file size 660 x 440px</div>
              </div>
            </div>
          </div>
        </vue2Dropzone>
        <div class="c-question-image-upload__error">{{ errorMessage }}</div>
        <br /><br />
        <div>
          <input
            id="caption"
            type="text"
            class="form-control"
            name="caption"
            v-model="fields.caption"
            v-validate="'required'"
            :placeholder="$t('Caption')"
          />
        </div>
        <button
          v-show="true"
          class="c-instantwin-random__step-1__btn btn-primary"
        >
          {{ $t("Publica") }}
        </button>
      </div>
    </v-form>
  </div>
</template>

<script>
import iconUpload from "@/assets/images/upload-file-product.svg";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import store from "@/store/store";
import ApiService from "@/common/services/api.service";

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  name: "UploadPagePlay",
  mixins: [],
  data() {
    return {
      fields: { uploadedContent: null, caption: "" },
      iconUpload,
      errorMessage: "",
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "someUrl",
        thumbnailWidth: 500,
        thumbnailHeight: 460,
        maxFiles: 1,
        maxFilesize: 10,
        acceptedFiles: "image/*",
        addRemoveLinks: true,
        uploadProgress: false,
        progress: false
      }
    };
  },
  methods: {
    async submit() {
      const id = this.$route.params.id;

      ApiService.post(
        `${store.getters.campaign.id}/upload/play/${id}`,
        this.fields
      ).then(() => {
        this.$router.push("/dashboard");
      });
    },
    async onFileAdded(e) {
      try {
        this.fields.uploadedContent = await toBase64(e);
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-question-image-upload {
  border: 2px dotted #7540ee;
  border-radius: 10px;
}

#upload-photo > div {
  height: 100%;
}

.c-instantwin-random__step-1__btn {
  color: #fff;
  padding: 10px 40px;
  border-radius: 10px;
  font-weight: 500;
  margin-top: 20px;
}

.upload__preview {
  //position: absolute;
  left: 2px;
  top: 2px;
  height: 100%;
  width: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropzone__icon-upload {
  width: 24px;
  height: 24px;
  margin-right: 10px;

  ::v-deep svg {
    width: 100%;
    height: 100%;
  }
}

.upload__icon {
  transform: rotate(-25deg);
  height: 20px;
}

.c-question-image-upload__error {
  text-align: center;
  color: red;
  font-size: 12px;
}

.c-upload-image-upload__dropzone {
  border: 1px dashed;
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;
  padding: 6px 0;
  font-size: 13px;
  border-radius: 2px;
  position: relative;
}

.dropzone__icon-upload {
  width: 24px;
  height: 24px;
  margin-right: 10px;

  ::v-deep svg {
    width: 100%;
    height: 100%;
  }
}

.form-container {
  display: flex;
  justify-content: center;
}

#upload-photo {
  width: 500px;
  height: 460px;
  padding: 5px;
}

.dz-image {
  width: 100%;
  height: 100%;
}

.vue-dropzone:hover {
  background-color: white;
}
</style>
